import React from 'react';
import Config from '../config';
import { Button } from 'antd';

const authUrl = `https://access.line.me/oauth2/v2.1/authorize?client_id=${Config.thirdPartySignIn.line}&redirect_uri=${Config.thirdPartySignIn.lineRedirectUrl}&response_type=code&scope=openid%20profile%20email&state=1111`

class LineSigninButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleOnSubmit = this.handleOnSubmit.bind(this);

    }

    handleOnSubmit = () => {
        console.log("Line Sign In");
        window.location.assign(authUrl);
    }

    render() {
        const { isSocialSubmitting } = this.props;

        return (
            <div>

                <Button
                    loading={isSocialSubmitting}
                    onClick={this.handleOnSubmit}
                    className="line"
                >
                </Button>

            </div>
        )
    }

}

export default LineSigninButton;
